document.addEventListener("turbo:load", () => {
  document.getElementById("limit-input").addEventListener("input", function() {
    if (this.value > 5) {
      this.value = 5;
    } else if (this.value < 1) {
      this.value = 1;
    }
  });
});